import React from 'react';
import '../styles/pages.css';

export default function Home() {
  return (
    <div className="page-container home-page">
      <header className="page-header">
        <img src="/assets/logo.png" alt="Annapolis Man Studios" className="logo" style={{ width: '75%', height: 'auto' }} />
      </header>
      
      <section className="hero-section">
        <div className="hero-content">
          <h2>Greetings!</h2>
          <p>
            Please bookmark this site and check back soon for updates on our upcoming projects. We are excited to share our endeavors with you in the near future!
          </p>
        </div>
        <time className="post-date" dateTime="2026-06-25">June 25, 2026</time>
      </section>
    </div>
  );
}
